import { render, staticRenderFns } from "./SegmentSettings.vue?vue&type=template&id=df9da740&"
import script from "./SegmentSettings.vue?vue&type=script&lang=js&"
export * from "./SegmentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports